import React from 'react';
import PropTypes from 'prop-types'
import DefaultAvatar from '../../../static/images/utils/avatars/Stock 6.svg'

const UserAvatar = props => {
  const {className, picture, size} = props

  return (
    <div className={`user-avatar ${className} ${size}`}>
      <img src={picture}
        alt="Avatar del usuario"/>
    </div>
  );
};

UserAvatar.propTypes = {
  size: PropTypes.string,
  className: PropTypes.string,
  picture: PropTypes.string,
}

UserAvatar.defaultProps = {
  size: '',
  className: '',
  picture: DefaultAvatar
}

export default UserAvatar;
